<template lang="pug">
form(id="payment-form" v-if="payment !== null")
    div.md-form-group(:class="{'invalid':errors.has('name')}")
      input.md-input(
      type="text"
      name="name"
      v-model="payment.name"
      v-validate="'required'"
      data-vv-as="name"
      :disabled="loading"
      ref="paymentName"
      )
      label Name
      span.form-error-msg(v-show="errors.has('name')") {{ errors.first('name') }}

    div.md-form-group(:class="{'invalid':errors.has('type')}")
      select.md-input(
      v-model="payment.type"
      :disabled="loading"
      )
        option(v-for="type in types" :key="type.type" v-bind:value="type.type") {{ type.name }}
      label Mode

    div.md-form-group(:class="{'invalid':errors.has('force_receipt_printing')}")
      select.md-input(
      v-model="payment.force_receipt_printing"
      :disabled="loading"
      )
        option(
          v-for="printing in forceReceiptPrintings"
          :key="printing.value"
          v-bind:value="printing.value"
        ) {{ printing.name }}
      label Force Receipt Printing

    div.md-form-group(:class="{'invalid':errors.has('receipt_copies')}")
      select.md-input(
      v-model="payment.receipt_copies"
      :disabled="loading"
      )
        option(
          v-for="copy in receiptCopies"
          :key="copy.value"
          v-bind:value="copy.value"
        ) {{ copy.name }}
      label Receipt Copies

    // div.md-form-group(v-if='filterMode' :class="{'invalid':errors.has('preset_amount')}")
    //   input.md-input(
    //   type="text"
    //   name="preset_amount"
    //   v-model="payment.preset_amount"
    //   v-validate="'decimal'"
    //   data-vv-as="preset amount"
    //   :disabled="loading"
    //   )
    //   label Preset amount
    //   span.form-error-msg(v-show="errors.has('preset_amount')") {{ errors.first('preset_amount') }}

    div.md-form-group.p-t-0
      label.multiselect-label {{ trans('general.applicable_outlets') }}
      multiselect(
        name="outlets"
        v-model="payment.outlets"
        :options="outletList"
        placeholder="Type to search"
        label="name"
        :multiple="true"
        :loading="onLoading('fetch-outlet')"
        :clear-on-select="false"
        :close-on-select="false"
        :hide-selected="true"
        track-by="id"
        @search-change="refreshOutletList"
      )
      span.md-input-msg {{ trans('general.leave_empty_if_applicable_to_all_outlets') }}

    div.md-form-group(style="margin-top:10px" :class="{'invalid':errors.has('source')}" v-if="payment.id !== undefined")
      input.md-input(
        type="text"
        name="source"
        v-model="payment.source"
        disabled
      )
      label Payment Source
      span.form-error-msg(v-show="errors.has('source')") {{ errors.first('source') }}

    div.md-form-group
      label Options
      div.form-group
        // p
        //   label.md-switch.has-value
        //     input(
        //     type="checkbox"
        //     name="require_reference"
        //     v-model="payment.require_reference"
        //     :disabled="loading"
        //     )
        //     i.indigo
        //     | Require reference number

        p
          label.md-switch.has-value
            input(
              type="checkbox"
              name="require_drawer_kick"
              v-model="payment.require_drawer_kick"
              :disabled="loading"
            )
            i.indigo
            | Drawer kick

        p
          label.md-switch.has-value
            input(
              type="checkbox"
              name="is_apply_rounding"
              v-model="payment.is_apply_rounding"
              :disabled="loading"
            )
            i.indigo
            | Apply rounding

        p
          label.md-switch.has-value
            input(
              type="checkbox"
              name="is_allow_split_payment"
              v-model="payment.is_allow_split_payment"
              :disabled="loading"
            )
            i.indigo
            | Allow Split Payment

        p(v-if="hasVoidRuleEnabled")
          label.md-switch.has-value
            input(
              type="checkbox"
              name="is_allow_void"
              v-model="payment.is_allow_void"
              :disabled="loading"
            )
            i.indigo
            | Allow Void

        p(v-if="hasIsAllowPaymentReductionEnabled")
          label.md-switch.has-value
            input(
              type="checkbox"
              name="is_allow_payment_reduction"
              v-model="payment.is_allow_payment_reduction"
              :disabled="loading"
            )
            i.indigo
            | Allow Payment Reduction

        p(v-if="hasIsShowPaymentInPosEnabled")
          label.md-switch.has-value
            input(
              type="checkbox"
              name="is_show_payment_in_pos"
              v-model="payment.is_show_payment_in_pos"
              :disabled="loading"
            )
            i.indigo
            | Show Payment in POS

    label(style="margin-top:10px" v-if="metadata.length > 0") Custom Field
      .row
        .col-md-6
          label.form-control-label Key
        .col-md-6
          label.form-control-label Value

      .row(v-for="(meta, index) in metadata" :key="index")
        .col-md-6
          .form-group(:class="{'has-danger': false}")
              input.form-control(
                  class="input-key"
                  :id="`key.${index}`"
                  ref="key"
                  type="text"
                  :name="`key[${index}]`"
                  v-model="meta.key"
                  v-focus=""
                  readonly
              )

        .col-md-6
          .form-group(:class="{'has-danger': false}")
              input.form-control(
                  :id="`value.${index}`"
                  ref="value"
                  type="text"
                  :name="`value[${index}]`"
                  v-model="meta.value"
                  v-focus=""
                  readonly
              )
</template>

<script>
import FormMixin from './form-mixin';
import types from './payment-types';
import { mapState, mapActions, mapGetters } from 'vuex';
import { default as MetaMixin, PAYMENT_MODULE } from '../../../mixins/meta';
import SettingsMixin from '../settings-mixin';

export default {
    mixins: [FormMixin, MetaMixin, SettingsMixin],
    props: {
        payment: {
            type: Object,
            required: true,
            default: () => ({
                name: '',
                type: 0,
                preset_amount: null,
                require_reference: false,
                require_drawer_kick: false,
                source: null,
                outlets: [],
                metadata: [],
                force_receipt_printing: 0,
                receipt_copies: 0,
            }),
        },
    },

    data() {
        return {
            outlets: [],
            outlets_loading: false,
            types: types,
            payment_id: [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 4 }],
            forceReceiptPrintings: [
                {
                    value: 0,
                    name: 'No Special Rule',
                },
                {
                    value: 1,
                    name: 'Force Printing',
                },
                {
                    value: 2,
                    name: 'Suppress Printing',
                },
            ],
            receiptCopies: [
                {
                    value: 0,
                    name: 'No Additional Receipt',
                },
                {
                    value: 1,
                    name: '1 Additional Receipt',
                },
                {
                    value: 2,
                    name: '2 Additional Receipts',
                },
            ],
        };
    },

    computed: {
        ...mapGetters('outlet', ['outletList']),

        filterMode() {
            let p = this.payment.type;
            let t = this.payment_id;
            let filter = t.find(t => t.id === p);

            if (filter) {
                return false;
            }

            return true;
        },
    },

    watch: {
        payment(data, oldValue) {
            this.$store.state.meta.metadata = [];
            this.getMeta(data.id, PAYMENT_MODULE);
        },
    },

    created() {
        this.getOutletList();
        this.getMeta(this.payment.id, PAYMENT_MODULE);
    },

    methods: {
        ...mapActions('outlet', ['getOutletList', 'getOutletListIfNecessary']),
        mapPaymentValue() {
            let payment = _.pick(this.payment, [
                'id',
                'name',
                'type',
                'preset_amount',
                'require_reference',
                'require_drawer_kick',
                'is_apply_rounding',
                'is_allow_split_payment',
                'force_receipt_printing',
                'receipt_copies',
                'is_allow_void',
                'is_allow_payment_reduction',
                'is_show_payment_in_pos',
            ]);

            return Object.assign(payment, {
                outlets: this.payment.outlets.map(obj => obj.id),
                ignoreMeta: true,
            });
        },

        refreshOutletList: _.debounce(function(query) {
            this.getOutletListIfNecessary({ query: query });
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/settings-payment-form.vue